import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { CARD_GROUP_FORM, PAYMENT_TYPE_CG, HOSE_TYPE_CG } from '../form-cardgroup-types';
import { getCustomerList } from '../form-cardgroup-helpers';
import { getParameters } from '../../../../helpers/helpers';
import { dropdown } from '../../../dropdown';
import useAuth from '../../../../hooks/auth-hooks';
import { displayCardGroupInfo } from './display-cardgroup';

import GetCardGroupIndividual from '../../../../routes/get-individual-card-group';

/**
 * Function gets information to display the individual card group
 * 
 * @returns void
 */
export const getIndividualCardGroup = async () => {
  if(!CARD_GROUP_FORM.cgUpdateForm) return;

  const groupID = getParameters('groupID');

  const [ cardgroup ] = await Promise.all([
    GetCardGroupIndividual(groupID)
  ]);

  const { accessType } = useAuth()!;
  const access = accessType === 'E';

  dropdown(PAYMENT_TYPE_CG, 'payment', 'Payment Type', false, true, access);
  dropdown(HOSE_TYPE_CG, 'hose', 'Hose Type', false, true, access);

  displayCardGroupInfo(cardgroup.body);

  getCustomerList(CARD_GROUP_FORM.cgSearchButton, CARD_GROUP_FORM.cgSearch, CARD_GROUP_FORM.cgSelectedCustContainer, cardgroup.body);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}